<template>
  <!--product body-->
  <div class="product_body">

    <div class="banner-top"><img src="@/assets/20220129/1643431673707083.jpg"></div>
    <div class="sevenpage">
      <div class="main">
        <div class="ntitle hidden-xs" style="margin-top:30px;margin-bottom:30px;">
          <h5>
            <img src="@/images/tb1.png" class="img-responsive" style="float:left;padding-top: 8px;"> 当前位置：
            <router-link to="/">首页</router-link>>>
            <router-link to="/product"> 产品中心</router-link>
          </h5>
        </div>

        <div>
          <div class="product-fl text-center hidden-xs" style="margin-bottom: 40px;margin-right: 40px;">
            <div class="pro-title"><span>PRODUCT CENTER</span>
              <p>产品中心</p>
            </div>

            <!--  left menus    -->
            <div class="treebox">
              <ul class="menu">
                <li class="level1" v-for="item of menuList">
                  <router-link :to="item.url">
                    {{ item.name }}
                    <i class="down"></i>
                  </router-link>
                </li>
              </ul>
            </div>

            <Contract/>

          </div>

          <main>
            <router-view></router-view>
          </main>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as productApi from '@/components/oh/prodcutApi'
import Contract from './Contract.vue'

export default {
  name: 'Product',
  components: {
    Contract
  },
  data() {
    return {
      menuList: []
    }
  },
  created() {
    this.menuList = productApi.getProductMenuList()
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ntitle h5 * {
  color: white;
  font-size: 14px;
  padding: 0 8px
}

.ntitle h5 *:hover {
  font-weight: bold
}
</style>
